export default "__VITE_ASSET__FZ6Pt3Ew__"